module.exports = __webpack_public_path__ + "static/media/todolist.908e0562.png";